export default __webpack_public_path__ + "static/media/foundU-permission.80b4edb4.png";